import React from "react";
import mixpanel from "mixpanel-browser";
import "../../common.scss";

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // $('#hi').css('opacity') = '1';
    mixpanel.track("Open Welcome Page");
  }

  render() {
    return (
      <div
        style={{
          color: "white",
          textAlign: "center",
          marginTop: "100px",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "20px",
            right: "120px",
            fontSize: "100px",
          }}
        >
          ↗
        </span>
        <div
          style={{
            position: "absolute",
            top: "120px",
            right: "220px",
            fontSize: "100px",
            textAlign: "right",
          }}
        >
          <h1 className="headline" style={{ margin: "0px" }}>
            Pin the extension
          </h1>

          <h2
            id="msg"
            className="subheadline"
            style={{
              height: "100px",
            }}
          >
            and click on the icon
          </h2>
          <h2 className="subheadline"></h2>
          <video
            controls
            autoPlay
            loop
            muted
            src="https://audiblogs-conversions-new.s3.us-east-1.amazonaws.com/images/Pin.mp4"
            type="video/mp4"
            style={{
              height: "40vh",
            }}
          />
        </div>
      </div>
    );
  }
}

export default Welcome;
